function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M386.871 610.815c-142.811-6.75-325.153-53.798-361.252-197.342C15.387 230.797 132.274 13.959 356.244 23.817 519.618 7.804 660.083 98.819 692 250.747c-5.073 166.534-95.732 367.195-304.5 360.068z",
  stroke: "currentColor",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
});

function Svg006(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 718 634",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzE4IDYzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMzg2Ljg3MSA2MTAuODE1Yy0xNDIuODExLTYuNzUtMzI1LjE1My01My43OTgtMzYxLjI1Mi0xOTcuMzQyQzE1LjM4NyAyMzAuNzk3IDEzMi4yNzQgMTMuOTU5IDM1Ni4yNDQgMjMuODE3IDUxOS42MTggNy44MDQgNjYwLjA4MyA5OC44MTkgNjkyIDI1MC43NDdjLTUuMDczIDE2Ni41MzQtOTUuNzMyIDM2Ny4xOTUtMzA0LjUgMzYwLjA2OHoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=";
export { Svg006 as ReactComponent };